/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/topappbar/top-app-bar.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatToolbarModule } from "@angular/material/toolbar";
import { RouterModule } from "@angular/router";
import { TopAppBarComponent } from "./top-app-bar.component";
import { TopAppBarService } from "./top-app-bar.service";
import * as i0 from "@angular/core";
export class TopAppBarModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: TopAppBarModule,
            providers: [
                TopAppBarService,
            ],
        };
    }
}
TopAppBarModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatInputModule,
                    MatButtonModule,
                    MatIconModule,
                    MatToolbarModule,
                    RouterModule,
                ],
                declarations: [
                    TopAppBarComponent,
                ],
                exports: [
                    TopAppBarComponent,
                ],
            },] },
];
/** @nocollapse */ TopAppBarModule.ɵmod = i0.ɵɵdefineNgModule({ type: TopAppBarModule });
/** @nocollapse */ TopAppBarModule.ɵinj = i0.ɵɵdefineInjector({ factory: function TopAppBarModule_Factory(t) { return new (t || TopAppBarModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            MatInputModule,
            MatButtonModule,
            MatIconModule,
            MatToolbarModule,
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TopAppBarModule, { declarations: [TopAppBarComponent], imports: [CommonModule,
        FormsModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        RouterModule], exports: [TopAppBarComponent] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(TopAppBarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    MatInputModule,
                    MatButtonModule,
                    MatIconModule,
                    MatToolbarModule,
                    RouterModule,
                ],
                declarations: [
                    TopAppBarComponent,
                ],
                exports: [
                    TopAppBarComponent,
                ],
            }]
    }], null, null); })();
//# sourceMappingURL=data:application/json;base64,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